import React from "react";
import {Input, Icon} from "semantic-ui-react";

interface GlobalSearchInputProps {
    onGlobalSearchChange: (value: string) => void;
    placeholder?: string;
    value?: string;
}

interface GlobalSearchInputState {
    value: string;
}

export default class GlobalSearchInput extends React.Component<GlobalSearchInputProps, GlobalSearchInputState> {
    constructor(props: GlobalSearchInputProps) {
        super(props);
        this.state = {
            value: props.value || "",
        };
    }

    componentDidUpdate(prevProps: GlobalSearchInputProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value || "" });
        }
    }

    handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({value: e.target.value});
    }

    handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            this.props.onGlobalSearchChange(this.state.value);
        }
    }

    handleBlur = () => {
        this.props.onGlobalSearchChange(this.state.value);
    }

    handleClear = () => {
        this.setState({value: ""}, () => {
            this.props.onGlobalSearchChange("");
        });
    }

    render() {
        return (
            <Input

                placeholder={this.props.placeholder || "Text Search..."}
                value={this.state.value}
                onChange={this.handleInputChange}
                onKeyPress={this.handleKeyPress}
                onBlur={this.handleBlur}
                style={{minWidth: "250px", height: "40px", marginTop: "5px"}} // Set minimum width
                icon={
                    <>
                        {!this.state.value && <Icon name="search" style={{cursor: "default", marginRight: "5px"}} />}
                        {this.state.value && (
                            <Icon
                                name="close"
                                link={true}
                                onClick={this.handleClear}
                                style={{cursor: "pointer"}}
                            />
                        )}
                    </>
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/GlobalSearchInput.tsx